import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			heHubPulsarsDiscoveryQuantumImgTxtSectionColLeftCls: string;
			heHubPulsarsDiscoveryQuantumImgTxtSectionColRightCls: string;
		}
	},

	slug: string
}

class Quantum extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('He Hub Pulsars Discovery Quantum Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryQuantumImgTxtSectionColLeftCls || '', 'he_hub_pulsars_discovery_quantum', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.heHubPulsarsDiscoveryQuantumImgTxtSectionColRightCls || '', 'he_hub_pulsars_discovery_quantum', { animCls: 'animate__zoomIn50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Quantum;